import { Component, Injectable } from '@angular/core';
import { CodeSnippet } from './code-snippet.interface';
import { Observable, Subject, lastValueFrom } from 'rxjs';
import { AddDatapointSnippet } from './add-datapoint.snippet';
import Mustache from 'mustache';
import { ScriptMode } from '../enums';


@Component({
    selector: 'call-nb-api',
    template: `
        <clx-popover
            #editorwindow
            *ngIf="isDialogOpen"
            [minWidth]="300"
            class="popup"
            height="auto"
            width="auto"
            title="Call Northbound API"
            i18n-title="@@script-editor.snippet.call-northbound-api.popup.title"
            [(visible)]="isDialogOpen"
            (visibleChange)="visibilityChanged($event)"
        >
            <div
                class="error message"
                *ngIf="error"
                i18n="@@script-editor.snippet.popup.message.plant-missing"
            >Please choose a plant/system before adding a datapoint</div>
            <clx-row has="full-size-columns big-layout">
                <clx-label i18n="@@script-editor.snippet.popup.reset-type.label">Reset Type</clx-label>
                <clx-item>
                    <clx-select name="method" #method>
                        <clx-value text="GET" value="GET"></clx-value>
                        <clx-value text="POST" value="POST"></clx-value>
                        <clx-value text="PUT" value="PUT"></clx-value>
                        <clx-value text="DELETE" value="DELETE"></clx-value>
                    </clx-select>
                </clx-item>
            </clx-row>

            <clx-row has="full-size-columns big-layout">
                <clx-label i18n="@@script-editor.snippet.popup.stop-script.label">stop script when HTTP response code is unequal to (optional)</clx-label>
                <clx-item>
                    <clx-select name="rcode" #rcode>
                        <clx-value text="<no stop condition>" value="" i18n-text="@@script-editor.snippet.popup.rcode.no-condition.text"></clx-value>
                        <clx-value text="OK" value="OK" i18n-text="@@script-editor.snippet.popup.rcode.ok.text"></clx-value>
                        <clx-value text="Created" value="Created" i18n-text="@@script-editor.snippet.popup.rcode.create.text"></clx-value>
                        <clx-value text="Accepted" value="Accepted" i18n-text="@@script-editor.snippet.popup.rcode.accepted.text"></clx-value>
                        <clx-value text="No Content" value="No Content" i18n-text="@@script-editor.snippet.popup.rcode.no-content.text"></clx-value>
                        <clx-value text="Bad Request" value="Bad Request" i18n-text="@@script-editor.snippet.popup.rcode.bad-request.text"></clx-value>
                        <clx-value text="Unauthorized" value="Unauthorized" i18n-text="@@script-editor.snippet.popup.rcode.unauthorized.text"></clx-value>
                        <clx-value text="Forbidden" value="Forbidden" i18n-text="@@script-editor.snippet.popup.rcode.forbidden.text"></clx-value>
                        <clx-value text="Not Found" value="Not Found" i18n-text="@@script-editor.snippet.popup.rcode.not-found.text"></clx-value>
                        <clx-value text="Conflict" value="Conflict" i18n-text="@@script-editor.snippet.popup.rcode.conflict.text"></clx-value>
                    </clx-select>
                </clx-item>
            </clx-row>

            <clx-row
                *ngIf="!systemId"
                type="buttons">
                <clx-button
                    i18n="@@script-editor.snippets.act-on-plant.button"
                    (click)="addApiCall({ method: method.value, rcode: rcode.value})"
                >Add</clx-button>
            </clx-row>

        </clx-popover>
    
    `,
    standalone: false
})
export class CallNBApi implements CodeSnippet{

    text: string = $localize`:@@script-editor.snippet.call-nb-api:call-northbound-api`;

    part = true;

    static category: string = 'climatix';

    isDialogOpen: boolean = false;

    data: any;

    subject: Subject<any> = new Subject()

    observable: Observable<any> = this.subject.asObservable();

    error: boolean = false;

    addApiCall(method) {
        this.subject.next(method)
        this.subject.complete()
    }

    async insert(): Promise<string> {

        this.subject = new Subject();
        this.observable = this.subject.asObservable();
        this.isDialogOpen = true;
        this.error = true;

        this.error = false;
        const value = await lastValueFrom(this.observable);
        this.isDialogOpen = false;

        if (!value) return '';

        let exp = "";
        let code = ", code";
        let addcomment = "";

        if (value.rcode !== "") {
            exp = ", '" + value.rcode + "'";
            code = "";
            addcomment = ", since expectation is added result code is ommited";
        }

        switch (value.method) {
            case "GET":
                return Mustache.render(`    -- call Northbound API with GET method (no payload${addcomment})
    local response${code} = api('GET /�Plants�'${exp})
`, value);

            case "POST":
                return Mustache.render(`    -- call Northbound API with POST method (with payload${addcomment})
    local response${code} = api('POST /�Plants�', { name = 'Plant' }${exp})
`, value);

            case "PUT":
                return Mustache.render(`    -- call Northbound API with PUT method (with payload${addcomment})
    local response${code} = api('PUT /�Plants/Pdeadbeef-dead-beef-dead-beefdeadbeef�', { name = 'Plant renamed' }${exp})
`, value);

            case "DELETE":
                return Mustache.render(`    -- call Northbound API with DELETE method (no payload${addcomment}) 
    local response${code} = api('DELETE /�Plants/Pdeadbeef-dead-beef-dead-beefdeadbeef�'${exp})
`, value);

            default:
                return '';
        }

    }

}